/* HommBútor collection cards (same form as the saját gyártású page): size pill under the title,
   savings under the price, percentage on the sale badge, warranty after the shipping line,
   "Személyre szabható" badge on products of the sajat-gyartasu collection.
   Data: the current page inline (#homm-kartya-adat), cards the filter app adds later from
   templates/search.kartya-adat.liquid (one request per 20 cards), cached per session.
   Runs again on DOM changes, because the filter app re-renders the grid. */
(function () {
  var sziget = document.getElementById('homm-kartya-adat');
  if (!sziget) { return; }
  var BADGE = (sziget.getAttribute('data-badge') || '').trim();
  var KULCS = 'homm-kartya-v1';
  var NYIL = { '↔': 'Szélesség', '⇲': 'Mélység', '↕': 'Magasság' };
  var adat = {};
  var kerve = {};
  try { adat = JSON.parse(sessionStorage.getItem(KULCS)) || {}; } catch (e) { adat = {}; }
  try { JSON.parse(sziget.textContent).forEach(function (r) { adat[r.h] = r; }); } catch (e) { /* fetch fills it */ }

  function elem(tag, osztaly, szoveg) {
    var e = document.createElement(tag);
    e.className = osztaly;
    if (szoveg) { e.textContent = szoveg; }
    return e;
  }

  function utana(horgony, uj) { horgony.parentNode.insertBefore(uj, horgony.nextSibling); }

  function diszit(k, r) {
    k.setAttribute('data-homm-kartya', '1');
    if (!r) { return; }
    var cim = k.querySelector('.product-card__title');
    if (r.m && cim) {
      var pill = elem('div', 'homm-kartya__meret');
      r.m.split(' · ').forEach(function (d) {
        var s = elem('span', '', d);
        var nev = NYIL[d.charAt(0)];
        if (nev) { s.title = nev; s.setAttribute('aria-label', nev + ': ' + d.slice(1).trim()); }
        pill.appendChild(s);
      });
      utana(cim, pill);
    }
    var ar = k.querySelector('.f-price');
    if (r.k && ar) { utana(ar, elem('div', 'homm-kartya__megtakaritas', r.k)); }
    var akcio = k.querySelector('.f-badge--sale');
    if (r.s && akcio) { akcio.textContent = r.s; akcio.classList.add('homm-kartya__szazalek'); }
    if (r.g) {
      var szall = k.querySelector('.product-card-shipping');
      if (szall) { szall.appendChild(document.createTextNode(' · ' + r.g)); }
      else if (ar) { utana(k.querySelector('.homm-kartya__megtakaritas') || ar, elem('div', 'homm-kartya__meta', r.g)); }
    }
    var kep = k.querySelector('.product-card__image-wrapper');
    if (r.b && BADGE && kep) { kep.appendChild(elem('span', 'homm-kartya__szabhato', BADGE)); }
  }

  function lekeres(hs) {
    fetch('/search?view=kartya-adat&q=' + encodeURIComponent(hs.join(',')), { credentials: 'same-origin' })
      .then(function (v) { return v.ok ? v.json() : []; })
      .then(function (lista) {
        hs.forEach(function (h) { adat[h] = false; });
        lista.forEach(function (r) { adat[r.h] = r; });
        try { sessionStorage.setItem(KULCS, JSON.stringify(adat)); } catch (e) { /* private mode: no cache */ }
        feldolgoz();
      })
      .catch(function () { /* cards stay in the theme's own form */ });
  }

  function feldolgoz() {
    var hianyzo = [];
    var kartyak = (document.getElementById('MainContent') || document).querySelectorAll('.product-card:not([data-homm-kartya])');
    for (var i = 0; i < kartyak.length; i++) {
      var a = kartyak[i].querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) { continue; }
      var h = decodeURIComponent(m[1]);
      if (h in adat) { diszit(kartyak[i], adat[h]); }
      else if (!kerve[h]) { kerve[h] = 1; hianyzo.push(h); }
    }
    for (var j = 0; j < hianyzo.length; j += 20) { lekeres(hianyzo.slice(j, j + 20)); }
  }

  var idozito;
  feldolgoz();
  new MutationObserver(function () {
    clearTimeout(idozito);
    idozito = setTimeout(feldolgoz, 50);
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
